import { LoanType } from '../../../../../../../../../common/constants/LoanType';
import { LoanStatusType } from '../../../../../../../../../common/constants/LoanStatusType';

/** What the Setup section needs to know about the loan being added/edited (it doesn't edit these itself). */
export interface SetupLoanContext {
    /** Id of the loan being edited; undefined/0 when adding a new loan (Loan Type is locked once a loan exists). */
    existingLoanId?: number;
    /** The loan's saved status; the FDILA fields only show for Outstanding/Repaid loans. */
    statusId: LoanStatusType;
    /** Sub notes only allow the sub-note loan types, can't pick a term, and can't edit the maturity date. */
    isSubNote: boolean;
    /** Shown read-only when the loan belongs to a master note. */
    masterNoteBfiNumber?: string;
}

export const defaultSetupLoanContext: SetupLoanContext = {
    existingLoanId: undefined,
    statusId: LoanStatusType.Approved,
    isSubNote: false,
    masterNoteBfiNumber: undefined,
};

export interface SetupForm {
    loanTypeId: LoanType | undefined;
    initialTermMonths: number | undefined;
    contractualExtension1Months: number | undefined;
    contractualExtension2Months: number | undefined;
    /** Dates are SQL-style strings, as produced by DateTimeBox. */
    approvalDate: string | undefined;
    noteDate: string | undefined;
    maturityDate: string | undefined;
    bfiNumber: string;
    loanNumber: string;
    pointOfContactId: string;
    underwriterId: string;
    callCodeType: number | undefined;
    inForbearance: boolean;
    forbearanceAgreementTerms: string;
}

export const emptySetupForm: SetupForm = {
    loanTypeId: undefined,
    initialTermMonths: undefined,
    contractualExtension1Months: undefined,
    contractualExtension2Months: undefined,
    approvalDate: undefined,
    noteDate: undefined,
    maturityDate: undefined,
    bfiNumber: '',
    loanNumber: '',
    pointOfContactId: '',
    underwriterId: '',
    callCodeType: undefined,
    inForbearance: false,
    forbearanceAgreementTerms: '',
};
